module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/fantasy-invest/3.png?a249a7dbf0d9e53ccf9aedd0ddf97038";